import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Profile_pic from '../../assets/images/profile_pic.svg';
import Arrow_down from '../../assets/images/arrow_down.svg';
import Settings from '../../assets/images/settings.svg';
import Favourits from '../../assets/images/star.svg';
import SuggestTrip from '../../assets/images/tripsugg.png';
import Sign_out from '../../assets/images/logout.svg';
import Nearby from '../../assets/images/nearby.svg';

const Navbar = () => {
    const [activeLink, setActiveLink] = useState(null);
    const [userData, setUserData] = useState(null);

    const location = useLocation();
    const auth = useAuth();
    const navigate = useNavigate();

    console.log(userData + "userdata")

    useEffect(() => {
        const userDataFromStorage = JSON.parse(localStorage.getItem('userData'));
        if (userDataFromStorage) {
            setUserData(userDataFromStorage);
        }
    }, []);


    useEffect(() => {
        const currentPath = location.pathname.substring(1);
        const currentHash = window.location.hash;
        if (currentHash === "#about") {
            setActiveLink('about');
        } else {
            setActiveLink(currentPath || 'home');
        }
    }, [location]);


    const addDefaultSrc = (ev) => {
        ev.target.src = Profile_pic;
    };
    const getNavbarBackground = () => {
        switch (activeLink) {
            case 'home':
                return 'transparent';
            case 'about':
            case 'places':
                return 'transparent';
            case 'contact':
                return '#333';
            default:
                return '#333';
        }
    };

    const navbarStyle = {
        backgroundColor: getNavbarBackground(),
    };

    const handleLinkClick = (link) => {
        setActiveLink(link);
        if (link === 'about') {
            const aboutRef = document.getElementById('about');
            if (aboutRef) {
                aboutRef.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };


    const handleLogout = async (event) => {
        event.preventDefault();
        if (localStorage.getItem('accessToken') !== null) {
            await auth.signout();
            navigate('/login');
        }


    }

    function closeOpenDropdowns(e) {
        let openDropdownEls = document.querySelectorAll("details.dropdown[open]");

        if (openDropdownEls.length > 0) {

            if (e.target.parentElement.nodeName.toUpperCase() !== "SUMMARY") {
                openDropdownEls.forEach((dropdown) => {
                    dropdown.removeAttribute("open");
                });
            }
        }
    }

    document.addEventListener("click", closeOpenDropdowns);


    return (
        <div className="navbar" style={navbarStyle}>
            <div className="left-links">
                <Link
                    to="/"
                    className={`link ${activeLink === 'home' ? 'active' : ''}`}
                    onClick={() => handleLinkClick('home')}
                >
                    <div className='underline'>
                        Home
                    </div>
                </Link>
                <Link
                    to="/#about"
                    className={`link ${activeLink === 'about' ? 'active' : ''}`}
                    onClick={() => handleLinkClick('about')}
                >
                    <div className='underline'>
                        About Us
                    </div>
                </Link>

                <Link
                    to="/places"
                    className={`link ${activeLink === 'places' ? 'active' : ''}`}
                    onClick={() => handleLinkClick('places')}
                >
                    <div className='underline'>
                        Places
                    </div>
                </Link>
                <Link
                    to="/chatbot"
                    className={`link ${activeLink === 'chatbot' ? 'active' : ''}`}
                    onClick={() => handleLinkClick('chatbot')}
                >
                    <div className='underline'>
                        Tourbot
                    </div>
                </Link>
            </div>
            <div className="right-links">
                <div>
                    <Link className='link' to="#english">En</Link>
                    <img className='arrow' src={Arrow_down} alt='arrow-down' />
                </div>


                {!auth.isAuthenticated ? (
                    <>
                        <Link className="login-button link" to="/login">Login</Link>
                        <Link className="signup-button" to="/signup">Sign Up</Link>
                    </>
                ) : (
                    <>
                        {userData && (
                            <>
                                <div className='profile-pic'>

                                    <img className='img-pic' onError={addDefaultSrc} src={userData.image_url} alt='profile-pic' />

                                </div>

                                <div class="dropdown-container">
                                    <details class="dropdown left">
                                        <summary className='name'>
                                            <span>{`${userData.firstName} `}</span>
                                            <span className='with-down-arrow'>{`${userData.lastName}`}</span>

                                        </summary>
                                        <ul>

                                            <li>
                                                <Link to="/profile-settings">
                                                    <img className='icon' src={Settings} alt='settings' /> Profile Settings
                                                </Link>
                                            </li>
                                            <li class="divider"></li>
                                            <li>
                                                <Link to="/favourits">
                                                    <img className='icon' src={Favourits} alt='favourits' /> Favourits
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/trip-suggestion">
                                                    <img className='icon' src={SuggestTrip} alt='SuggestTrip' /> Trip Suggestion
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/nearest-places">
                                                    <img className='icon' src={Nearby} alt='nearby' /> Nearest places
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="#" onClick={handleLogout}>
                                                    <img className='icon' src={Sign_out} alt='signout' /> Sign Out
                                                </Link>
                                            </li>
                                        </ul>
                                    </details>
                                </div>

                            </>
                        )}

                    </>
                )}
            </div>
        </div>
    );
}

export default Navbar;
